import * as React from "react";
import type { SVGProps } from "react";
const SvgIconApple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M8.17 4.1c.63 0 1.43-.44 1.9-1.03.43-.53.74-1.28.74-2.02q0-.15-.02-.29c-.71.03-1.56.49-2.07 1.1-.4.48-.76 1.21-.76 1.97l.02.25zM5.94 15.24c.86 0 1.25-.6 2.33-.6 1.1 0 1.34.58 2.3.58s1.58-.9 2.18-1.79c.67-1 .95-2 .96-2.05-.06-.02-1.87-.78-1.87-2.92 0-1.86 1.43-2.7 1.5-2.77-.94-1.4-2.38-1.43-2.77-1.43-1.06 0-1.93.66-2.47.66-.6 0-1.37-.62-2.29-.62-1.75 0-3.52 1.49-3.52 4.3 0 1.75.66 3.6 1.47 4.8.7 1.01 1.3 1.84 2.18 1.84"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconApple;
